import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CancelQuoteException extends QuoteException {
}
